import React, { useState } from 'react';

import CloseIcon from "../../assets/images/close.png";



const AdminOverlay = ({ mode, closePopup, user, doit, error_message, resetAdminErrorFN, created, departments }) => {

    const [firstname, setFirstname] = useState(user ? user.first_name : "");
    const [lastname, setLastname] = useState(user ? user.last_name : "");
    const [email, setEmail] = useState(user ? user.email : "");
    const [password, setPassword] = useState("");
    const [repeatpassword, setRepeatPassword] = useState("");
    const [role, setRole] = useState(user ? user.role.toLowerCase() : "");
    const [status, setStatus] = useState(user ? user.status.toLowerCase() : "");
    const [department, setDepartment] = useState(user ? user.department_id : "");

    const handleSubmit = (e) => {
        resetAdminErrorFN();
        e.preventDefault();
        doit(mode === "create" ? { first_name: firstname, last_name: lastname, email, password, repeatpassword, role, status, department_id: department } : { user_id: user.user_id, first_name: firstname, last_name: lastname, email, role, status, department_id: department });
    }

    if (created) {
        closePopup();
    }


    return (
        <div className="bg-white rounded-2xl shadow-xl p-6 w-[420px]">
            {/* Header */}
            <div className="flex items-start justify-between mb-4">
                <div>
                    <h1 className="text-lg font-semibold text-[#111827]">
                        {mode === "create" ? "Create User" : "Edit User"}
                    </h1>
                    <p className="text-xs text-gray-500 mt-1">
                        {mode === "create"
                            ? "Create a new user account"
                            : "Update user information"}
                    </p>
                </div>
                <img
                    src={CloseIcon}
                    alt="Close"
                    className="w-5 h-5 cursor-pointer opacity-70 hover:opacity-100"
                    onClick={() => closePopup()}
                />
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="space-y-4">
                {/* First Name */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        First Name
                    </label>
                    <input
                        type="text"
                        className="w-full px-3 py-2 rounded-md border border-gray-300 bg-[#EEF0ED] text-sm text-black focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400"
                        value={firstname}
                        onChange={(e) => setFirstname(e.target.value)}
                        required
                    />
                </div>

                {/* Last Name */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Last Name
                    </label>
                    <input
                        type="text"
                        className="w-full px-3 py-2 rounded-md border border-gray-300 bg-[#EEF0ED] text-sm text-black focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400"
                        value={lastname}
                        onChange={(e) => setLastname(e.target.value)}
                        required
                    />
                </div>

                {/* Email */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Email
                    </label>
                    <input
                        type="email"
                        className="w-full px-3 py-2 rounded-md border border-gray-300 bg-[#EEF0ED] text-sm text-black focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>

                {/* Passwords only in create mode */}
                {mode === "create" && (
                    <>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Password
                            </label>
                            <input
                                type="password"
                                className="w-full px-3 py-2 rounded-md border border-gray-300 bg-[#EEF0ED] text-sm text-black focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Repeat Password
                            </label>
                            <input
                                type="password"
                                className="w-full px-3 py-2 rounded-md border border-gray-300 bg-[#EEF0ED] text-sm text-black focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400"
                                value={repeatpassword}
                                onChange={(e) => setRepeatPassword(e.target.value)}
                                required
                            />
                        </div>
                    </>
                )}

                {/* Role */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Role
                    </label>
                    <select
                        className="w-full px-3 py-2 rounded-md border border-gray-300 bg-[#EEF0ED] text-sm text-black focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                        required
                    >
                        <option value="">Select Role</option>
                        <option value="admin">Admin</option>
                        <option value="auditor">Auditor</option>
                        <option value="user">User</option>
                    </select>
                </div>

                {/* Status */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Status
                    </label>
                    <select
                        className="w-full px-3 py-2 rounded-md border border-gray-300 bg-[#EEF0ED] text-sm text-black focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        required
                    >
                        <option value="">Select Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                    </select>
                </div>

                {/* Department (only for user role) */}
                {role === "user" && (
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Department
                        </label>
                        <select
                            className="w-full px-3 py-2 rounded-md border border-gray-300 bg-[#EEF0ED] text-sm text-black focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400"
                            value={department}
                            onChange={(e) => setDepartment(e.target.value)}
                            required
                        >
                            <option value="">Select Department</option>
                            {departments &&
                                departments.map((department) => (
                                    <option
                                        key={department.department_id}
                                        value={department.department_id}
                                    >
                                        {department.name}
                                    </option>
                                ))}
                        </select>
                    </div>
                )}

                {/* Footer buttons */}
                <div className="flex items-center justify-end gap-3 pt-2">
                    <button
                        type="button"
                        onClick={closePopup}
                        className="px-4 py-2 rounded-md border border-gray-300 text-sm text-gray-700 bg-white hover:bg-gray-50"
                    >
                        Cancel
                    </button>
                    <button
                        className="px-4 py-2 rounded-md text-sm font-semibold bg-[#111827] text-white hover:bg-[#020617] transition-colors"
                        type="submit"
                    >
                        {mode === "create" ? "Create User" : "Update User"}
                    </button>
                </div>
            </form>

            {error_message && (
                <p className="mt-3 text-sm text-red-500">{error_message}</p>
            )}
        </div>
    );

};

export default AdminOverlay;
